











import Vue from 'vue'
import { mdiCart } from '@mdi/js'
import { ruleNotEmptyString } from '@/utils'

export default Vue.extend({
    name: 'FieldOrderNumber',

    data: () => ({ mdiCart }),

    methods: { ruleNotEmptyString },
})
